import { useFormContext } from 'react-hook-form';
import { Typography } from '@material-ui/core';

export const NutritionistSearchTestStep3Form = () => {
  const form = useFormContext();

  return <Typography>Step 3 form</Typography>;
};
